import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-100 d-flex align-items-center justify-content-between" }
const _hoisted_2 = {
  class: "w-100 w-md-25",
  style: {"font-size":"var(--font-sm)","color":"#64646480","font-weight":"400"}
}
const _hoisted_3 = { class: "pagination-content w-100 d-flex align-items-center justify-content-end" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["onClick", "data-testid"]
const _hoisted_6 = ["disabled"]

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    currentPageNumber: {},
    perPage: {},
    totalItems: {},
    maxVisibleButtons: {}
  },
  emits: ["pagechanged"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const totalPages = computed(() => Math.ceil(props.totalItems / props.perPage));
const isInFirstPage = computed(() => props.currentPageNumber === 1);
const isInLastPage = computed(() => props.currentPageNumber === totalPages.value);

const onClickPreviousPage = () => {
  if (isInFirstPage.value) return;
  emit("pagechanged", props.currentPageNumber - 1);
};

const goToPage = (page: number) => {
  if (page < 1 || page > totalPages.value) return;
  emit("pagechanged", page);
};

const onClickNextPage = () => {
  if (isInLastPage.value) return;
  emit("pagechanged", props.currentPageNumber + 1);
};  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Showing " + _toDisplayString((__props.perPage * (__props.currentPageNumber - 1)) + 1) + " - " + _toDisplayString(Math.min(__props.perPage * __props.currentPageNumber, __props.totalItems)) + " of " + _toDisplayString(__props.totalItems), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn-style me-2 me-md-3",
        type: "button",
        onClick: onClickPreviousPage,
        disabled: isInFirstPage.value,
        "aria-label": "Go to previous page",
        "data-testid": "previous-page-btn"
      }, " Previous ", 8, _hoisted_4),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
        return (_openBlock(), _createElementBlock("span", { key: page }, [
          _createElementVNode("button", {
            class: _normalizeClass(['pagination-btn', __props.currentPageNumber == page ? 'active' : '']),
            style: {"margin":"0 0.125rem"},
            onClick: () => goToPage(page),
            type: "button",
            "data-testid": `go-to-page-btn${page}`
          }, _toDisplayString(page), 11, _hoisted_5)
        ]))
      }), 128)),
      _createElementVNode("button", {
        class: "btn-style ms-2 ms-md-3",
        type: "button",
        onClick: onClickNextPage,
        disabled: isInLastPage.value,
        "aria-label": "Go to next page",
        "data-testid": "next-page-btn"
      }, " Next ", 8, _hoisted_6)
    ])
  ]))
}
}

})